"use client"

import { HStack, Separator, Text } from "@chakra-ui/react"
import { type FC } from "react"

import { type DividerBlock as DividerBlockType } from "@/types/database"

import {
  type ContentBlockTitleNumberProps,
  formatContentBlockTitleNumber,
} from "./ContentBlockTitle"

interface DividerBlockProps extends ContentBlockTitleNumberProps {
  block: DividerBlockType
}
// TODO: NEEDS FIXING
const DividerBlock: FC<DividerBlockProps> = ({ block, titleNumber }) => {
  const { title } = block
  const formattedTitleNumber = formatContentBlockTitleNumber(titleNumber)

  return (
    <HStack className="divider-block internal-padding" position="relative">
      <HStack alignItems="center" gap={4} w="full">
        {title && (
          <HStack gap={2}>
            {formattedTitleNumber && (
              <Text
                as="span"
                color={{ base: "primary.500", _dark: "primary.200" }}
                fontFamily="mono"
                fontSize="0.8rem"
                fontWeight="medium"
                lineHeight="inherit"
              >
                {formattedTitleNumber}
              </Text>
            )}
            <Text
              color="fg.subtle"
              fontSize="sm"
              fontWeight="medium"
              whiteSpace="nowrap"
            >
              {title}
            </Text>
          </HStack>
        )}
        <Separator flex="1" />
      </HStack>
    </HStack>
  )
}

export default DividerBlock
